/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1903853583 — Знижки */

import { getCurrencyBySubUnits } from "../../../../../shared";
import { useAppStore } from "../../../../../shared/hooks/useAppStore";
import { PriceDisplay } from "../PriceDisplay";

export function PriceWithoutDiscount({ className }: { className?: string }) {
    const vm = useAppStore((store) => store.vm);
    const order = useAppStore((store) => store.order);

  return (
    <PriceDisplay
        className={className}
        currencyCode={vm?.currency_code}
        totalAmount={getCurrencyBySubUnits((order?.amount || 0))}
    />
  )
}
